import http from './http';
import { listResource } from './listResource';

export async function listClients(options = {}) {
  return listResource('/clients', options);
}
// Activar/Desactivar Cliente
export const updateClientStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/clients/${id}/status`, { is_active: isActive });
// Eliminar Cliente
export const deleteClient = (id) => http.delete(`/clients/${id}`);

export async function getClientById(id) {
  const res = await http.get(`/clients/${id}`);
  return res.data?.data ?? res.data;
}

export async function createClient(payload) {
  payload.medium = 'Administrador';
  const res = await http.post('/clients', payload);
  return res.data?.data ?? res.data;
}

export async function updateClient(id, payload) {
  const res = await http.put(`/clients/${id}`, payload);
  return res.data?.data ?? res.data;
}

export async function uploadClientPhoto(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/client-photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

export async function checkClientNicknameAvailability(nickname, excludeClientId) {
  if (!nickname) return true;

  const params = {
    nickname,
  };

  if (excludeClientId !== undefined && excludeClientId !== null) {
    params.exclude_client_id = excludeClientId;
  }

  const res = await http.get('/clients/nickname/availability', { params });
  const data = res.data?.data ?? res.data;

  if (typeof data === 'boolean') return data;

  return Boolean(data?.available);
}

// Reporte 
export async function getClientsReport(params = {}) {
  const res = await http.get('/clients/report', { params });
  const items = res.data?.items ?? res.data?.data ?? res.data ?? [];
  const total =
    res.data?.total ??
    res.headers?.['x-total-count'] ??
    (Array.isArray(items) ? items.length : 0);
  return { items, total };
}

export async function getClientPlanReport(params = {}) {
  const res = await http.get('/clients/report-plan', { params });
  const items = res.data?.items ?? res.data?.data ?? res.data ?? [];
  const total =
    res.data?.total ??
    res.headers?.['x-total-count'] ??
    (Array.isArray(items) ? items.length : 0);
  return { items, total };
}